export default "__VITE_ASSET__d6f03940__"